"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ContactLabel = require("./ContactLabel");
Object.keys(_ContactLabel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ContactLabel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContactLabel[key];
    }
  });
});